class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      let sectionId = this.getAttribute("data-sectionid");
      let container = document.querySelector(".faq-container--" + sectionId);

      $(".faq-questions-" + sectionId).click(function (e) {
        e.preventDefault();
        let $this = $(this);
        let $nextAnswer = $this.next();
        let $faChevronDown = $this.find(".fa-chevron-arrows .fa-chevron-down");
        let $faChevronUp = $this.find(".fa-chevron-arrows .fa-chevron-up");

        // Close any open answers in this container
        $(container)
          .find(".faq-accordion-wrapper")
          .each(function () {
            let $accordionWrapper = $(this);
            if (
              $accordionWrapper.hasClass("active") &&
              !$accordionWrapper.is($this.parent())
            ) {
              $accordionWrapper.removeClass("active");
              $accordionWrapper
                .find(".faq-answers")
                .removeClass("show")
                .slideUp(350);
              $accordionWrapper
                .find(".fa-chevron-arrows .fa-chevron-down")
                .css({ display: "flex" });
              $accordionWrapper
                .find(".fa-chevron-arrows .fa-chevron-up")
                .css({ display: "none" });
            }
          });

        // Toggle the clicked FAQ answer
        if ($nextAnswer.hasClass("show")) {
          $nextAnswer.removeClass("show").slideUp(350);
          $this.parent().removeClass("active");
          $faChevronDown.css({ display: "flex" });
          $faChevronUp.css({ display: "none" });
        } else {
          $nextAnswer.toggleClass("show").slideToggle(350);
          $this.parent().toggleClass("active");
          $faChevronDown.css({ display: "none" });
          $faChevronUp.css({ display: "flex" });
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);

class BlogpostSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      let sectionId = this.getAttribute("data-sectionid");
      var swiper = new Swiper(".post-slider--" + sectionId, {
        slidesPerView: 1,
        spaceBetween: 4,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          700: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          1000: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("blog-post-slider", BlogpostSlider);

class HeroBanner extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(window).on("load", function () {
        $(".logo-slider").css("opacity", 1); // Set opacity to 1 when window has fully loaded
      });

      // ✅ Define opacities array FIRST
      const opacities = [0, 0.2, 0.6, 0.8, 1, 0.8, 0.6, 0.4, 0.2, 0];

      // ✅ Opacity update function
      function updateOpacities(swiper) {
        const centerIndex = Math.floor(opacities.length / 2);
        swiper.slides.forEach((slide, i) => {
          const offset = i - swiper.activeIndex + centerIndex;
          const index = Math.abs(offset);
          slide.style.opacity =
            opacities[index] !== undefined ? opacities[index] : 0;
        });
      }

      // ✅ Now initialize Swiper
      const newswiper = new Swiper(".logo-slider", {
        direction: "vertical",
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        speed: 3000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true,
        },
        on: {
          init() {
            updateOpacities(this);
          },
          slideChangeTransitionStart() {
            updateOpacities(this);
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("hero-banner", HeroBanner);

class FeatureSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      // ✅ Define opacities array FIRST
      const opacities = [0, 0.2, 0.6, 0.8, 1, 0.8, 0.6, 0.4, 0.2, 0];

      // ✅ Opacity update function
      function updateOpacities(swiper) {
        const centerIndex = Math.floor(opacities.length / 2);
        swiper.slides.forEach((slide, i) => {
          const offset = i - swiper.activeIndex + centerIndex;
          const index = Math.abs(offset);
          slide.style.opacity =
            opacities[index] !== undefined ? opacities[index] : 0;
        });
      }

      // ✅ Now initialize Swiper
      const newswiper = new Swiper(".logo-slider", {
        direction: "vertical",
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        speed: 3000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true,
        },
        on: {
          init() {
            updateOpacities(this);
          },
          slideChangeTransitionStart() {
            updateOpacities(this);
          },
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("feature-slider", FeatureSlider);

class TextSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper2 = new Swiper(".pagination-slider", {
        slidesPerView: "auto",
        spaceBetween: 4,
        watchSlidesProgress: true,
      });

      var swiper = new Swiper(".custom-review-slider", {
        slidesPerView: 1,
        loop: true,
        effect: "fade", // <- fade effect
        fadeEffect: {
          crossFade: true, // smoother crossfade
        },
        spaceBetween: 8,
        navigation: {
          nextEl: ".custom-review-next",
          prevEl: ".custom-review-prev",
        },
        thumbs: {
          swiper: swiper2, // <-- assign swiper2 here
        },
        autoplay: {
          delay: 3000, // 3 seconds per slide
          disableOnInteraction: false, // keep autoplay even after user interaction
        },
        speed: 800,
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("text-slider", TextSlider);

class UseSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const swiper = new Swiper(".how-to-use-slider", {
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        pagination: {
          el: ".how-to-use-pagination",
          clickable: true,
        },
      });

      const swiper1 = new Swiper(".how-to-use-slider-1", {
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        pagination: {
          el: ".how-to-use-pagination",
          clickable: true,
        },
      });

      const swiper2 = new Swiper(".how-to-use-slider-2", {
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: false,
        speed: 800,
      });

      const swiper3 = new Swiper(".how-to-use-slider-3", {
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: false,
        speed: 800,
      });

      const swipers = [swiper1, swiper2, swiper3];
      let syncing = false;

      // Core sync logic
      function sync(source, targets) {
        const syncIndex = () => {
          if (syncing) return;
          syncing = true;
          const index = source.realIndex;

          targets.forEach((t) => {
            if (t.realIndex !== index) {
              t.slideToLoop(index, 800, false);
            }
          });

          setTimeout(() => {
            syncing = false;
          }, 100);
        };

        // Sync on autoplay or manual slide change
        source.on("slideChangeTransitionStart", syncIndex);

        // Sync on swipe touch end
        source.on("touchEnd", () => {
          requestAnimationFrame(syncIndex);
        });
      }

      // Setup all-to-all sync
      swipers.forEach((swiper, i) => {
        const others = swipers.filter((_, j) => j !== i);
        sync(swiper, others);
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("use-slider", UseSlider);


class ImageWithTextSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const textSlider = this.querySelector(".text-slider");
      const imageSlider = this.querySelector(".image-slider");
      const pagination = this.querySelector(".desktop-pagination");
      const paginationMob = this.querySelector(".mobile-pagination");
      const nextBtn = this.querySelector(".custom-slider-next");
      const prevBtn = this.querySelector(".custom-slider-prev");
      const nextBtnMob = this.querySelector(".standout-next");
      const prevBtnMob = this.querySelector(".standout-prev");

      const swiper1 = new Swiper(textSlider, {
        init: false,
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        speed: 800,
        pagination: {
          el: [pagination , paginationMob ],
          clickable: true,
        },
        navigation: {
          nextEl: [nextBtn , nextBtnMob ],
          prevEl: [prevBtn , prevBtnMob ],
        },
      });
     

      const swiper2 = new Swiper(imageSlider, {
        init: false,
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        speed: 800,
        pagination: {
          el: [pagination , paginationMob ],
          clickable: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });

      const swipers = [swiper1, swiper2];
      let syncing = false;

      function sync(source, targets) {
        const syncIndex = () => {
          if (syncing) return;
          syncing = true;
          const index = source.realIndex;
          targets.forEach(t => {
            if (t.realIndex !== index) {
              t.slideToLoop(index, 800, false);
            }
          });
          setTimeout(() => syncing = false, 100);
        };

        source.on("slideChangeTransitionStart", syncIndex);
        source.on("touchEnd", () => requestAnimationFrame(syncIndex));
      }

      swipers.forEach((swiper, i) => {
        const others = swipers.filter((_, j) => j !== i);
        sync(swiper, others);
        swiper.init();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("image-with-text-slider", ImageWithTextSlider);


// class ImageWithTextSlider extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);

//       const textSlider = this.querySelector(".text-slider");
//       const imageSlider = this.querySelector(".image-slider");
//       const pagination = this.querySelector(".how-to-use-pagination");
//       const nextBtn = this.querySelector(".custom-slider-next");
//       const prevBtn = this.querySelector(".custom-slider-prev");

//       const swiper1 = new Swiper(textSlider, {
//         init: false,
//         loop: true,
//         effect: "fade",
//         fadeEffect: { crossFade: true },
//         speed: 800,
//         pagination: {
//           el: pagination,
//           clickable: true,
//         },
//         navigation: {
//           nextEl: nextBtn,
//           prevEl: prevBtn,
//         },
//       });

//       const swiper2 = new Swiper(imageSlider, {
//         init: false,
//         loop: true,
//         effect: "fade",
//         fadeEffect: { crossFade: true },
//         speed: 800,
//         pagination: {
//           el: pagination,
//           clickable: true,
//         },
//         navigation: {
//           nextEl: nextBtn,
//           prevEl: prevBtn,
//         },
//       });

//       const swipers = [swiper1, swiper2];
//       let syncing = false;

//       function disableButtons() {
//         nextBtn.classList.add("swiper-button-disabled");
//         prevBtn.classList.add("swiper-button-disabled");
//         nextBtn.setAttribute("disabled", "true");
//         prevBtn.setAttribute("disabled", "true");
//       }

//       function enableButtons() {
//         nextBtn.classList.remove("swiper-button-disabled");
//         prevBtn.classList.remove("swiper-button-disabled");
//         nextBtn.removeAttribute("disabled");
//         prevBtn.removeAttribute("disabled");
//       }

//       function sync(source, targets) {
//         const syncIndex = () => {
//           if (syncing) return;
//           syncing = true;
//           disableButtons(); // 🔒 disable when transition starts

//           const index = source.realIndex;
//           targets.forEach(t => {
//             if (t.realIndex !== index) {
//               t.slideToLoop(index, 800, false);
//             }
//           });

//           setTimeout(() => {
//             syncing = false;
//             enableButtons(); // ✅ re-enable after delay
//           }, 850);
//         };

//         source.on("slideChangeTransitionStart", syncIndex);
//         source.on("touchEnd", () => requestAnimationFrame(syncIndex));
//       }

//       swipers.forEach((swiper, i) => {
//         const others = swipers.filter((_, j) => j !== i);
//         sync(swiper, others);
//         swiper.init();
//       });

//       // 🔄 Also disable buttons immediately on click
//       nextBtn.addEventListener("click", disableButtons);
//       prevBtn.addEventListener("click", disableButtons);
//     };

//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }

// customElements.define("image-with-text-slider", ImageWithTextSlider);